import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import publicService from '../../services/publicService';
import Image from '../common/Image';
import './CategoryShowcase.css';

const CategoryShowcase = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [section, setSection] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const [featured, sectionData] = await Promise.all([
          publicService.getFeaturedCategories(4),
          publicService.getHomeSection('category_showcase').catch(() => null),
        ]);
        setSection(sectionData || null);
        setCategories(Array.isArray(featured) ? featured.slice(0, 4) : []);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to load category showcase', error);
        setCategories([]);
      }
    };
    loadData();
  }, []);

  const handleCategoryClick = (slug) => {
    navigate(`/products?category=${slug}`);
  };

  if (categories.length === 0) {
    return null;
  }

  return (
    <section className="category-showcase">
      {(section?.heading || section?.subheading) && (
        <header className="category-showcase-header" data-reveal-item>
          {section.heading && <h2 className="category-showcase-heading">{section.heading}</h2>}
          {section.subheading && <p className="category-showcase-subheading">{section.subheading}</p>}
        </header>
      )}

      <div className="category-showcase-grid">
        {categories.map((cat, idx) => (
          <article
            key={cat.id}
            className={`category-card ${idx === 1 ? 'category-card--featured' : ''}`}
            data-reveal-item
            style={{ '--reveal-index': idx + 1 }}
          >
            <div className="category-card-text">
              {cat.kicker && <span className="category-card-kicker">{cat.kicker}</span>}
              {cat.card_title && (
                <h3 className="category-card-title">{cat.card_title}</h3>
              )}
              {cat.card_description && (
                <p className="category-card-description">{cat.card_description}</p>
              )}
              {cat.button_text && (
                <button
                  type="button"
                  className={`category-card-button ${idx === 1 ? 'category-card-button--filled' : ''}`}
                  onClick={() => handleCategoryClick(cat.slug)}
                >
                  {cat.button_text}
                  <span className="category-card-button-arrow" aria-hidden="true">→</span>
                </button>
              )}
            </div>
            {cat.image_url && (
              <div className="category-card-image-wrap">
                <Image
                  src={cat.image_url}
                  alt={cat.name}
                  className="category-card-image"
                />
              </div>
            )}
          </article>
        ))}
      </div>
    </section>
  );
};

export default CategoryShowcase;
